import React, { useState } from 'react';
import { Typography, Box, Grid, useMediaQuery } from '@mui/material';
import { Button, Link } from 'gatsby-theme-material-ui';
import Section from '../../shared/Section/Section';
import PaymentCard from '../../shared/PaymentCard/PaymentCard';
import { DoneIcon } from '../../shared/PaymentCard/DoneIcon';
import ModalBlock from '../../shared/ModalBlock/ModalBlock';
import ConsultationModal from '../../shared/Modals/ConsultationModal';
import sectionStyles, {
  createTitleColorTheme,
} from '../../shared/Section/styles';
import { preparePrice } from '../../helpers/lib';
import styles from './styles';

const loanData = {
  message: 'Узнать про оплату частями',
  sentContent: {
    title: 'Заявка на оплату частями принята',
    message: 'Скоро с вами свяжется куратор',
  },
};
// этот компонент одинаковый для DS JS но для онлайна будет другой
function Payment({
  program,
  programType,
  title,
  data: { description },
  group,
  loanLeadData,
  imgs,
  ymEvents = {},
  myTargetEvents = {},
  noPrice = false,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [isLoanModalOpen, setIsLoanModalOpen] = useState(false);
  const modalOpenButton = (
    <Box sx={{ mt: 'auto' }}>
      <Button
        onClick={() => setIsLoanModalOpen(true)}
        variant="kitPrimary"
        size="large"
      >
        Узнать подробнее
      </Button>
    </Box>
  );

  return (
    <Section
      theme="lightPurple"
      position={'bottom'}
      anchor="price"
      wrapperStyles={{ minHeight: { xs: 521, lg: 460 } }}
      withoutBg
    >
      <Grid container sx={{ gap: { xs: 4, lg: 14 }, height: '100%' }}>
        <Grid item xs={12} lg={4}>
          {title && (
            <Typography
              variant="desktopH2"
              sx={{
                ...sectionStyles.title,
                ...createTitleColorTheme('lightPurple'),
              }}
            >
              {Array.isArray(title)
                ? title.map((item) => (
                    <Typography key={item}>{item}</Typography>
                  ))
                : title}
            </Typography>
          )}
          {description.map((item, index) => (
            <Box key={index} sx={styles.descriptionItem}>
              <DoneIcon isSm={isSm} />
              <Box>
                {Array.isArray(item.content) ? (
                  item.content.map((p) => (
                    <Typography
                      variant="desktopP2"
                      sx={styles.content_link_wrapper}
                      color={'kit.text.main'}
                      key={p}
                    >
                      {p}
                    </Typography>
                  ))
                ) : (
                  <Typography
                    variant="desktopP2"
                    sx={styles.content_link_wrapper}
                    color={'kit.text.main'}
                  >
                    {item.content}
                    &nbsp;
                    {item.link && (
                      <Box sx={{ display: 'flex' }}>
                        {item.link.text && (
                          <Typography>{item.link.text}&nbsp;</Typography>
                        )}
                        <Link
                          to={item.link.url}
                          sx={{ fontSize: { xs: 14, lg: 16 } }}
                          variant="kitPrimary"
                          typography="desktopP2"
                        >
                          {item.link.title}
                        </Link>
                      </Box>
                    )}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
          {!noPrice && group?.price?.bankLoanPricePerMonth && (
            <Box mt={{ xs: 4, lg: 12 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <Typography mr="8px" variant="desktopH3" color="kit.text.main">
                  от
                </Typography>

                <Typography
                  variant="desktopH2"
                  component="p"
                  color="kit.text.main"
                >
                  {preparePrice(group.price.bankLoanPricePerMonth)} ₽/
                </Typography>
                <Typography variant="desktopH3" ml="8px">
                  месяц
                </Typography>
              </Box>
              <Box>
                <Typography variant="desktopP1">
                  или сразу {preparePrice(group.price.fullPrice)} ₽
                </Typography>
              </Box>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} lg={5} sx={{ position: 'relative' }}>
          <PaymentCard imgs={imgs} modalOpenButton={modalOpenButton} />
        </Grid>
        {isSm && <Box mt={'auto'}>{modalOpenButton}</Box>}
      </Grid>
      <ModalBlock
        isOpen={isLoanModalOpen}
        handleClose={() => setIsLoanModalOpen(false)}
      >
        <ConsultationModal
          extraLeadData={loanLeadData}
          formData={{
            ...loanData,
            title: program,
            subtitle: programType,
          }}
          buttonLabel="оставить заявку"
          ymSubmitEventTypes={[ymEvents.paymentFormSubmitCredit]}
          myTargetSubmitEventTypes={[myTargetEvents.paymentFormSubmitCredit]}
        />
      </ModalBlock>
    </Section>
  );
}

export default Payment;
